const getHash = () =>
    Date.now().toString(36) + Math.random().toString(36).substring(2)

const state = {
    messages: [],
    itemsChanged: false,
}

const getters = {}

const mutations = {
    SET_MESSAGES(state, messages) {
        state.messages = messages
    },
    SET_CHANGED(state, x) {
        state.itemsChanged = x
    },
}

const actions = {
    load({ commit }, initialItems) {
        const messages = initialItems.map(x => {
            x.hash = x.hash || getHash()
            return x
        })
        commit('SET_MESSAGES', messages)
        commit('SET_CHANGED', false)
    },

    clear({ commit }) {
        commit('SET_MESSAGES', [])
        commit('SET_CHANGED', false)
    },

    merge({ state, commit }, item) {
        item.hash = item.hash || getHash()
        const messages = [...state.messages]
        console.log('messages before:', [...messages])
        let index = messages.findIndex(x => x.hash == item.hash)
        if (index >= 0) messages.splice(index, 1, item)
        else messages.push(item)
        console.log('messages after', [...messages])
        commit('SET_CHANGED', true)
        commit('SET_MESSAGES', messages)
    },

    delete({ state, commit }, hash) {
        const messages = [...state.messages]
        const index = messages.findIndex(x => x.hash == hash)
        messages.splice(index, 1)
        commit('SET_CHANGED', true)
        commit('SET_MESSAGES', messages)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
